type LaunchListener = (launchInstanceId: string) => void
type FocusListener = () => void

export interface EhrLaunchCoordinationAdapter {
  publish: (launchInstanceId: string) => void
  subscribe: (listener: LaunchListener) => () => void
  subscribeToFocus: (listener: FocusListener) => () => void
}

const createBrowserAdapter = (): EhrLaunchCoordinationAdapter => {
  let channel: BroadcastChannel | undefined
  const getChannel = () => {
    if (typeof BroadcastChannel === 'undefined') return undefined
    channel ??= new BroadcastChannel('rxpad-ehr-launch')
    return channel
  }

  return {
    publish: (launchInstanceId) => getChannel()?.postMessage(launchInstanceId),
    subscribe: (listener) => {
      const activeChannel = getChannel()
      if (!activeChannel) return () => undefined
      const onMessage = (event: MessageEvent<unknown>) => {
        if (typeof event.data === 'string' && event.data) listener(event.data)
      }
      activeChannel.addEventListener('message', onMessage)
      return () => activeChannel.removeEventListener('message', onMessage)
    },
    subscribeToFocus: (listener) => {
      if (typeof window === 'undefined' || typeof document === 'undefined') return () => undefined
      const onFocus = () => listener()
      const onVisibility = () => {
        if (document.visibilityState === 'visible') listener()
      }
      window.addEventListener('focus', onFocus)
      document.addEventListener('visibilitychange', onVisibility)
      return () => {
        window.removeEventListener('focus', onFocus)
        document.removeEventListener('visibilitychange', onVisibility)
      }
    },
  }
}

let adapter = createBrowserAdapter()

export const ehrLaunchCoordination = {
  publish: (launchInstanceId: string) => adapter.publish(launchInstanceId),
  subscribe: (listener: LaunchListener) => adapter.subscribe(listener),
  subscribeToFocus: (listener: FocusListener) => adapter.subscribeToFocus(listener),
}

export const setEhrLaunchCoordinationAdapterForTests = (
  replacement: EhrLaunchCoordinationAdapter
) => {
  adapter = replacement
}
